import React from "react";
import { Typography, Button, Container, Paper } from "@mui/material";

export default function WarningPage() {
    return (
        <Container
            maxWidth="sm"
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "100vh",
            }}
        >
            <Paper
                elevation={6}
                sx={{
                    p: 6,
                    textAlign: "center",
                    bgcolor: "error.dark",
                    color: "white",
                    borderRadius: 4,
                }}
            >
                <Typography variant="h3" gutterBottom color="error.light">
                    🚨 Warning!
                </Typography>

                <Typography variant="h6" gutterBottom>
                    Developer Tools have been detected.
                </Typography>

                <Typography variant="body1" sx={{ mb: 4 }}>
                    For security reasons, you have been redirected to this page.
                </Typography>

                <Button
                    variant="contained"
                    color="warning"
                    size="large"
                    onClick={() => (window.location.href = "/")}
                    sx={{ fontWeight: "bold", borderRadius: 3 }}
                >
                    Go Back Home
                </Button>
            </Paper>
        </Container>
    );
}